import React from "react";
// import Breadcrumb from "../../components/Breadcrumb";
import UnitView from "../../components/Units/UnitView";


const ViewUnit = () => {
  return (
    <>
 
        {/* Breadcrumb */}
        {/* <Breadcrumb title="View Unit" /> */}

        {/* AddUserLayer */}
        <UnitView />


    </>
  );
};

export default ViewUnit;